import Vue from 'vue'
import store from '@/store'

/** 顶栏切换商户后派发，各列表页监听并刷新 */
export const STORE_CONTEXT_EVENT = 'store-context-changed'

export interface StoreContextDetail {
  storeId?: string
  storeName?: string
}

/** 从 Vuex 读取当前选中的商户 ID（响应式来源） */
export function getFilterStoreId(): string {
  const user = (store.state as any).user
  return (user && user.storeId) || ''
}

export function dispatchStoreContextChanged(detail?: StoreContextDetail) {
  Vue.nextTick(() => {
    window.dispatchEvent(
      new CustomEvent(STORE_CONTEXT_EVENT, { detail: detail || {} }),
    )
  })
}

/** 应用启动后监听 storeId 变化，统一触发各页刷新 */
export function setupStoreContextWatcher() {
  let prev: string | undefined
  store.watch(
    (state: any) => (state.user && state.user.storeId) || '',
    (id: string) => {
      if (prev === undefined) {
        prev = id
        return
      }
      if (id !== prev) {
        prev = id
        dispatchStoreContextChanged()
      }
    },
  )
}

export function appendStoreFilter<T extends Record<string, unknown>>(params: T): T {
  const storeId = getFilterStoreId()
  if (storeId) {
    return { ...params, storeId: Number(storeId) }
  }
  return params
}
